/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Export_FailedInputs */

const vi_customer_debt_export_failed = /** @type {(inputs: Customer_Debt_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xuất được sổ công nợ`)
};

/**

* @param {Customer_Debt_Export_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_export_failed = /** @type {((inputs?: Customer_Debt_Export_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Export_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_export_failed(inputs)
});